import { OsLocationBlockReason } from '../services/location-access.service';

/**
 * Whether the server has to be told that somebody's location access has gone.
 *
 * WHY THIS EXISTS. Until 15 October 2026 there were two ways to withdraw
 * location access and they did not do the same thing. The toggle inside the
 * application sent `locationEnabled: false`, and the API erased the stored
 * device position. Revoking the permission in the phone's own settings, which
 * is the gesture most people make, reached no server call at all:
 * reconcileLocationState hid the map and warned, while the sync only ever
 * synced the ON direction. So the position survived the withdrawal, and the
 * nearby search kept matching the profile on it.
 *
 * Found while checking the published privacy policy against the code, not from
 * a report, which is why it had stood unnoticed.
 *
 * WHY ONLY `permission_denied`, decided by Maude on 15 October 2026.
 * `location_services_disabled` means the phone's location is off for
 * everything, which is not a withdrawal of consent addressed to us: people
 * turn it off to save battery and back on ten minutes later, and erasing the
 * position each time would mean rewriting it each time. Taking the permission
 * away from Smatchy specifically is the gesture that means « stop using it ».
 *
 * WHY THE SIGNED-IN CHECK. The route is authenticated. Calling it with nobody
 * signed in answers 401, the interceptor renews the token, Firebase answers
 * that the user record does not exist, and our own tidying up is reported as a
 * production error. That exact sequence is why DisconnectUserAction guards its
 * two calls the same way; the comment there spells it out.
 */
export const theServerMustForgetTheDevicePosition = (
  reason: OsLocationBlockReason,
  somebodyIsSignedIn: boolean,
): boolean => reason === 'permission_denied' && somebodyIsSignedIn;
